module.exports = __webpack_public_path__ + "img/Naadiya-Walji.27150542.jpg";